import React from 'react';
import Contact from '../components/Contact';

const ContactPage = () => {
  return (
    <main className="pt-20">
      <Contact />
    </main>
  );
};

export default ContactPage; 